// extracted by mini-css-extract-plugin
export var dividerContainer = "_6z-0";
export var line = "_6z-1";